"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthContext = void 0;
const react_1 = __importDefault(require("react"));
const useAuthReducer_1 = require("./useAuthReducer");
const AuthContext = react_1.default.createContext({
    client: { bootstrap: () => useAuthReducer_1.initialState },
    dispatch: () => { },
    state: useAuthReducer_1.initialState,
});
function useAuthContext() {
    return react_1.default.useContext(AuthContext);
}
exports.useAuthContext = useAuthContext;
exports.default = AuthContext;
